import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../actions/index';
import { Outlet, NavLink } from "react-router-dom";


const Logout = ({layout}) => {

    const LoginLogout = useSelector(state => state.LoginLogout);
    const dispatch = useDispatch();

    // const LoginLayout = () => {          
    //     return <a href="/" className="logout-btn"  onClick={() => logoutSubmit()}><span className="material-icons-outlined">logout</span> Logout</a>;
    // }

    const LoginLayout = () => { 
        
        if(layout==="alertbox"){
            return <button type="button" onClick={() => logoutSubmit()}>Login Again</button>
        }else{
            return <NavLink exact="true" className="logout-btn" activeclass="active" to="/login"  onClick={() => logoutSubmit()}><span className="material-icons-outlined">logout</span> Logout </NavLink>
        }
    }

    /******Logout button click*******/
    function logoutSubmit(){
        dispatch(allActions.LoginLogoutActions.logOut());
        localStorage.setItem('authlogin',"");
    }

    return (
        <>
            <LoginLayout />
        </>
    )
}

export default Logout;